import 'datatables.net';
import 'datatables.net-bs';
import * as $ from 'jquery';
import * as React from 'react';
import getJwtToken from '../../utils/getJwtToken';
import { MsalContext } from "../common/msal";


interface Props {
    children?: React.ReactNode;
    className?: string;
    rest?: Array<any>;
    ajaxUrl: string;
    ajaxData?: Function;
    ajaxDataFilter?: Function;
    useAuth?: boolean;
    onDraw?: Function;
    order?: any[];
    searchPlaceholder?: string;
    stateSave?: boolean;
}

export default class DataTable extends React.Component<Props, {}> {
    private table: HTMLTableElement | null;
    private dataTable: any;
    static contextType = MsalContext;
    context!: React.ContextType<typeof MsalContext>;

    constructor(props: Props) {
        super(props);

        this.table = null;

        this.reload = this.reload.bind(this);
    }

    public render() {
        // Stable id so DataTables stateSave uses a consistent localStorage key across remounts
        const tableId = "dt-" + this.props.ajaxUrl.replace(/[^a-zA-Z0-9]/g, "-");

        return <table id={tableId} className={"table datatable dt-responsive nowrap " + this.props.className} style={{ width: "100%" }} {...this.props.rest} ref={x => this.table = x}>
            {this.props.children}
        </table>;
    }

    public async componentDidMount() {

        let __this = this;
        let ajaxSettings: any = {
            url: __this.props.ajaxUrl,
            data: function (data: any) {
                if (__this.props.ajaxData !== undefined) {
                    data = __this.props.ajaxData(data);
                }
                return data;
            },
            dataFilter: function (data: any) {
                if (__this.props.ajaxDataFilter !== undefined) {
                    data = __this.props.ajaxDataFilter(data);
                }
                return data;
            },
        };

        if (this.props.useAuth) {
            let config = require(`../../config.${HostingEnv}.ts`) as any;
            let accessToken = localStorage.getItem("access_token");
            let token = getJwtToken();
            if (token === null || new Date().getTime() >= token.exp * 1000) {
                const accounts = this.context.accounts;
                if (accounts.length > 0) {
                    const scope = BQS
                        ? config.authRequestBQS.scopes[0]
                        : config.authRequestCQS.scopes[0];

                    const account = this.context.accounts[0];
                    if (account) {
                        const request = {
                            scopes: [scope],
                            account: account,
                            interactionType: 'Silent'
                        };
                        const instance = this.context.instance;
                        console.log("DT: Silent token acquisition silently...");
                        await instance
                            .acquireTokenSilent(request)
                            .then((response) => {
                                if (response) {
                                    localStorage.setItem("access_token", response.accessToken);
                                    token = getJwtToken();
                                    accessToken = localStorage.getItem("access_token");
                                    ajaxSettings.headers = {
                                        Authorization: `Bearer ${accessToken}`,
                                    };

                                    if (token !== null && new Date().getTime() < token.exp * 1000) {

                                        let settings: any = {
                                            dom: "<'table-action'fl>t<'row'<'col-sm-12 text-center'p>>",
                                            responsive: true,
                                            language: {
                                                search: '<span class="search-icon"></span>'
                                            },
                                            serverSide: true,
                                            ajax: ajaxSettings,
                                        };

                                        if (this.props.order) {
                                            settings.order = this.props.order;
                                        }
                                        if (this.props.searchPlaceholder) {
                                            settings.language.searchPlaceholder = this.props.searchPlaceholder;
                                        }
                                        if (this.props.stateSave) {
                                            settings.stateSave = true;
                                        }

                                        this.dataTable = $(this.table!)
                                            .DataTable(settings)
                                            .on("init.dt", function () {
                                                var $wrapper = $(__this.table!).closest(".dataTables_wrapper");
                                                $wrapper.find(".search-icon").click(function () {
                                                    $(this).next().toggleClass('open');
                                                    $(this).next().fadeToggle("fast", "linear");
                                                });
                                                if (__this.props.stateSave) {
                                                    var savedSearch = __this.dataTable.state().search.search;
                                                    if (savedSearch && savedSearch.length > 0) {
                                                        $wrapper.find(".search-icon").next().addClass('open').show();
                                                    }
                                                }
                                            }).on("draw", function () {
                                                if (__this.props.onDraw !== undefined) {
                                                    __this.props.onDraw(__this.table!);
                                                }
                                            });
                                    }
                                }
                            })
                            .catch(async (err) => {
                                await instance.loginRedirect({
                                    scopes: [scope],
                                    account: account
                                });
                            });
                    }
                }
            }
            else {
                ajaxSettings.headers = {
                    Authorization: `Bearer ${accessToken}`,
                };

                if (new Date().getTime() < token.exp * 1000) {

                    let settings: any = {
                        dom: "<'table-action'fl>t<'row'<'col-sm-12 text-center'p>>",
                        responsive: true,
                        language: {
                            search: '<span class="search-icon"></span>'
                        },
                        serverSide: true,
                        ajax: ajaxSettings,
                    };

                    if (this.props.order) {
                        settings.order = this.props.order;
                    }
                    if (this.props.searchPlaceholder) {
                        settings.language.searchPlaceholder = this.props.searchPlaceholder;
                    }
                    if (this.props.stateSave) {
                        settings.stateSave = true;
                    }

                    this.dataTable = $(this.table!)
                        .DataTable(settings)
                        .on("init.dt", function () {
                            var $wrapper = $(__this.table!).closest(".dataTables_wrapper");
                            $wrapper.find(".search-icon").click(function () {
                                $(this).next().toggleClass('open');
                                $(this).next().fadeToggle("fast", "linear");
                            });
                            if (__this.props.stateSave) {
                                var savedSearch = __this.dataTable.state().search.search;
                                if (savedSearch && savedSearch.length > 0) {
                                    $wrapper.find(".search-icon").next().addClass('open').show();
                                }
                            }
                        }).on("draw", function () {
                            if (__this.props.onDraw !== undefined) {
                                __this.props.onDraw(__this.table!);
                            }
                        });
                }
            }
        }
        else {
            let settings: any = {
                dom: "<'table-action'fl>t<'row'<'col-sm-12 text-center'p>>",
                responsive: true,
                language: {
                    search: '<span class="search-icon"></span>'
                },
                serverSide: true,
                ajax: ajaxSettings,
            };

            if (this.props.order) {
                settings.order = this.props.order;
            }
            if (this.props.searchPlaceholder) {
                settings.language.searchPlaceholder = this.props.searchPlaceholder;
            }
            if (this.props.stateSave) {
                settings.stateSave = true;
            }

            this.dataTable = $(this.table!)
                .DataTable(settings)
                .on("init.dt", function () {
                    var $wrapper = $(__this.table!).closest(".dataTables_wrapper");
                    $wrapper.find(".search-icon").click(function () {
                        $(this).next().toggleClass('open');
                        $(this).next().fadeToggle("fast", "linear");
                    });
                    if (__this.props.stateSave) {
                        var savedSearch = __this.dataTable.state().search.search;
                        if (savedSearch && savedSearch.length > 0) {
                            $wrapper.find(".search-icon").next().addClass('open').show();
                        }
                    }
                }).on("draw", function () {
                    if (__this.props.onDraw !== undefined) {
                        __this.props.onDraw(__this.table!);
                    }
                });
        }
    }

    public reload() {
        this.dataTable.ajax.reload(null, false);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/common/DataTable.tsx